let outsideClickBound = false

document.addEventListener('turbo:load', () => {
  document.querySelectorAll('.hamburger').forEach(hamburger => {
    hamburger.addEventListener('click', () => {
      toggleHamburger(hamburger)
    })
  })

  if (!outsideClickBound) {
    outsideClickBound = true

    document.addEventListener('click', (event) => {
      document.querySelectorAll('.hamburger.is-active').forEach(hamburger => {
        const toggle = hamburgerToggle(hamburger)
        if (!toggle) return

        const clickInsideButton = hamburger.contains(event.target)
        const clickInsideMenu = toggle.contains(event.target)
        if (!clickInsideButton && !clickInsideMenu) {
          closeHamburger(hamburger, toggle)
        }
      })
    })
  }
})

document.addEventListener('turbo:before-cache', () => {
  document.querySelectorAll('.hamburger').forEach(hamburger => {
    closeHamburger(hamburger);
  })
})

function hamburgerToggle(hamburger) {
  const toggleId = hamburger.getAttribute('aria-controls')
  return toggleId ? document.getElementById(toggleId) : false
}

function toggleHamburger(hamburger) {
  const toggle = hamburgerToggle(hamburger);
  if (!toggle) return

  if (toggle.classList.contains('is-open')) {
    closeHamburger(hamburger, toggle)
  } else {
    openHamburger(hamburger, toggle)
  }
}

function closeHamburger(hamburger, toggle = null) {
  hamburger.classList.remove('is-active')
  if (!toggle) toggle = hamburgerToggle(hamburger);
  if (toggle) toggle.classList.remove('is-open')
}

function openHamburger(hamburger, toggle = null) {
  hamburger.classList.add('is-active')
  if (!toggle) toggle = hamburgerToggle(hamburger);
  if (toggle) toggle.classList.add('is-open')
}
